import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNominationStudentPayTo({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.55.65a.75.75 0 01.576 1.23L9.723 4.768c.523.378.976.72 1.36 1.028l.414.339a.75.75 0 01-.968 1.146 21.284 21.284 0 00-.76-.61l-.46-.347-.512-.374H5.488C2.794 7.675 1.5 9.468 1.5 11.322c0 1.466 1.96 2.547 5.655 2.547a.75.75 0 010 1.5C2.742 15.369 0 13.858 0 11.322c0-2.385 1.513-4.543 4.44-6.48L1.974 1.88A.75.75 0 012.55.65zm1.612 7.935l.077.068 2.545 2.545a.75.75 0 01.067.984l-.067.077-2.545 2.545a.75.75 0 01-1.128-.984l.067-.076 1.272-1.274H8.98a.75.75 0 01-.102-1.493l.102-.007h4.456l-1.258-1.257a.75.75 0 01-.067-.984l.067-.076a.75.75 0 01.984-.068zM9.949 2.15H4.15l1.475 1.77a.747.747 0 01.172.53h2.504a.747.747 0 01.172-.53l1.475-1.77z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNominationStudentPayTo.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNominationStudentPayTo.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgNominationStudentPayTo svgRef={ref} {...props} />
));
export default ForwardRef;
